import { useQuery } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const useGetAppraisalsQuery = (workspaceId?: string, sourceId?: string) => {
  const { appraisals } = useAvApi();

  const data = useQuery({
    enabled: !!workspaceId && !!sourceId,
    queryKey: ['workspace-appraisals', workspaceId, sourceId],
    queryFn: async () => {
      if (!workspaceId) return;
      const data = await appraisals.getAppraisalsProjectByProjectId({
        projectId: workspaceId,
      }, {
        sourceId
      });

      return data.data;
    },
    staleTime: 10000
  });

  return data;
};
